import CareModelDiagram from './CareModelDiagram'

export default function CareModel() {
  return (
    <section className="care-model" id="care-model">
      <div className="section-container">
        <div className="care-model-header">
          <div className="section-label reveal">The expedited care model</div>
        </div>

        <div className="care-model-narrative">
          <p className="care-model-lede reveal">
            <span className="care-model-lede-big">Seven years.</span> That&rsquo;s how long the
            average woman waits for a diagnosis, told her pain is normal while a disease that
            affects 1 in 10 women goes unnamed.
          </p>
          <p className="reveal reveal-delay-1">
            This is not a gap in medicine. It&rsquo;s a failure of access.{' '}
            <strong>Pelvia exists to end it</strong>, collapsing a decade of diagnostic
            wandering into 72 hours.
          </p>
        </div>

        <CareModelDiagram />

        <p className="care-model-mission reveal">
          Our mission: get you the right care, faster. <em>Your pain is real.</em>
        </p>
      </div>
    </section>
  )
}
